import { ProductItem } from './../../../../components/user-dashboard/product/models/product';
import { SharedProductService } from './../../../../components/user-dashboard/product/shared-product.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedOfferService } from './../../../../components/user-dashboard/offer/shared-offer.service';
import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { SortingTypeModel, FilteringTypeModel } from 'src/app/models/portal';

import {
  trigger,
  transition,
  style,
  state,
  animate,
} from '@angular/animations';
import { listAnimation } from 'src/app/shared/animations/animations';
import { StudentItem } from 'src/app/components/user-dashboard/product/models/course';
import { LocalPaginationConfig } from 'src/app/models/owner-dashboard';

export enum OffersListScopeEnum {
  all = 'all',
  portal = 'portal',
  product = 'product',
  custom = 'custom',
}

@Component({
  selector: 'app-students-list',
  templateUrl: './students-list.component.html',
  styleUrls: ['./students-list.component.css'],
  animations: [
    trigger('shrinkOut', [
      state('in', style({})),
      transition('* => void', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition('void => true', [
        style({ transform: 'translateX(-150px)', opacity: 0 }),
        animate(400, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    trigger('shrinkOutOnlyIn', [
      state('in', style({})),
      transition('void => *', [
        style({ transform: 'translateX(250px)', opacity: 0 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    listAnimation
  ],
})
export class StudentsListComponent implements OnInit, OnChanges {
  @Input() studentsList: StudentItem[] = [];
  @Input() demoStudentsList: StudentItem[] = [];
  @Input() loaded: boolean = false;
  showDemoStudents: boolean = false;
  @Input('showDemoStudents') set setShowDemoStudents(value: boolean) {
    this.showDemoStudents = value;
  }

  expandedStudentId: number | null = null;
  toggleExpand(id: number) {
    if (this.expandedStudentId === id) {
      this.expandedStudentId = null;
    } else {
      this.expandedStudentId = id;
    }
  }

  paginationConfig: LocalPaginationConfig = new LocalPaginationConfig({
    currentPage: 1,
    startIndex: 0,
    numberInPage: 8,
    endIndex: 8,
  });
  // Pagination


  // Sort And Filtering Features
  searchWord: string = '';
  sortObject: SortingTypeModel = {
    displayName: 'Newest',
    column: 'createdAt',
    order: 'dsc',
  };
  sortTypes: SortingTypeModel[] = [
    { displayName: 'Newest', column: 'createdAt', order: 'dsc' },
    { displayName: 'Oldest', column: 'createdAt', order: 'asc' },
    { displayName: 'Recently Updated', column: 'updatedAt', order: 'dsc' },
    { displayName: 'A-Z Title', column: 'name', order: 'asc' },
    { displayName: 'Z-A Title', column: 'name', order: 'dsc' },
  ];

  constructor(
    public sharedProductService: SharedProductService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // this.offersList = await this.sharedOfferService.getOffers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentsList'] && this.studentsList?.length > 0) {
      this.checkAndExpandStudent();
    }
  }

  private checkAndExpandStudent() {
    const studentIdParam = this.route.snapshot.queryParams['studentId'];
    if (studentIdParam) {
      const studentId = Number(studentIdParam);
      const student = this.studentsList.find(s => s.id === studentId);

      if (student) {
        // Expand the student
        this.expandedStudentId = studentId;

        // Scroll to the element
        setTimeout(() => {
          const element = document.getElementById(`student-row-${studentId}`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // remove the query param to prevent re-scrolling ?? Optional, user might want to refresh and see it again.
          }
        }, 500); // Delay to ensure rendering
      }
    }
  }

  // Sort And Filtering Features
  sortTypeChange(sortObject: SortingTypeModel) {
    this.sortObject = sortObject;
  }

  deleteProduct(product: ProductItem) {
    this.sharedProductService.deleteProductAlert(product);
  }

  cloneProduct(product: ProductItem) {
    this.sharedProductService.cloneProductAlert(product);
  }

  viewProduct(id: number) {
    this.router.navigate(['dashboard', 'product', id, 'view']);
  }

  editProduct(id: number) {
    this.router.navigate(['dashboard', 'product', id, 'edit']);
  }

  goToTutorials() {
    this.router.navigate(['/dashboard/tutorials']);
  }

  onSearchWordChange(value: any) {
    this.searchWord = value;
  }

  consoleHandler(index: number, student: any) {
    return student ? student.id : index;
  }

}
